import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, Shield } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { SECTIONS } from "@/lib/sections";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

const itemClass = ({ isActive }: { isActive: boolean }) =>
  `flex items-center gap-3 rounded-lg border-l-2 px-3 py-3 text-sm transition-colors ${
    isActive ? "border-[#16294D] bg-[#16294D] font-semibold text-white" : "border-transparent text-[#5A6170] hover:bg-[#ECE3D3]"
  }`;

export function MobileNav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const close = () => setOpen(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button className="-ml-1 rounded-md p-2 text-slate-700 hover:bg-slate-100 lg:hidden" aria-label="Abrir menú" data-testid="mobile-menu-button">
          <Menu className="h-5 w-5" />
        </button>
      </SheetTrigger>
      <SheetContent side="left" className="w-72 bg-white p-5" data-testid="mobile-menu-sheet">
        <SheetHeader className="mb-6 text-left">
          <SheetTitle><Logo /></SheetTitle>
        </SheetHeader>
        <nav className="flex flex-col gap-1">
          {SECTIONS.map(({ slug, path, label, icon: Icon }) => (
            <NavLink key={slug} to={path} onClick={close} className={itemClass} data-testid={`mobile-menu-link-${slug}`}>
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
          {user && user.role === "admin" && (
            <NavLink to="/admin" onClick={close} className={itemClass} data-testid="mobile-menu-link-admin">
              <Shield className="h-4 w-4" /> Admin
            </NavLink>
          )}
        </nav>
      </SheetContent>
    </Sheet>
  );
}
